import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  item: null,
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  createSetting({ commit }, item) {
    return this.$axios.$post('admin/settings/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
      return response.data
    })
  },
  removeSetting({ commit }, item) {
    return this.$axios.$delete(`admin/settings/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateSetting({ commit }, item) {
    return this.$axios.$put(`admin/settings/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
      return response.data
    })
  },
  fetchSetting({ commit }, id) {
    return this.$axios.$get(`admin/settings/${id}`).then((response) => {
      return response.data
    })
  },
  fetchSettings({ commit }) {
    return this.$axios.$get('admin/settings').then((response) => {
      commit('load', response.data)
      return response.data
    })
  },
}
